import type { Project } from '@/api/client';

export type ProjectNoteDraftItem = { id: string; content: string };

export interface ProjectNotesLocalDraft {
  items: ProjectNoteDraftItem[];
  onItemsChange: (items: ProjectNoteDraftItem[]) => void;
  titleName: string;
}

/** Минимальная модель строки заметки для списка (проект или персона) */
export type NotesPopoverNoteLike = {
  note_id: string;
  note_content: string;
  created_at: string;
  created_by_name?: string | null;
};

export type ProjectNotesPopoverServerProps = {
  open: boolean;
  onClose: () => void;
  project: Project;
  anchorEl: HTMLElement | null;
};

/** Заметки персоны (чтец и др.) — тот же UI и поведение, что у заметок проекта */
export type PersonNotesPopoverServerProps = {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  personId: string;
  titleName: string;
};

export type ProjectNotesPopoverLocalDraftProps = {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  localDraft: ProjectNotesLocalDraft;
};

export type ProjectNotesPopoverProps = ProjectNotesPopoverServerProps | ProjectNotesPopoverLocalDraftProps;

export function isLocalDraftNotesProps(p: ProjectNotesPopoverProps): p is ProjectNotesPopoverLocalDraftProps {
  return 'localDraft' in p && p.localDraft != null;
}
